export default __webpack_public_path__ + "static/media/ReconVelocityVDPLogo.161bab00.svg";